module.exports = new __parcel__URL__("light.5ffcf568.svg").toString();